// module imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// file imports
import axiosInstance from '@/lib/axios';

const getFeedbackReportDetails = createAsyncThunk('feedbackDetail/getFeedbackReportDetails', async ({ slug, submissionId }: { slug: string; submissionId: string }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/feedback/${slug}/report-details?submissionId=${submissionId}`);
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.error || 'Retrieving feedback report details failed');
  }
});

const feedbackDetailSlice = createSlice({
  name: 'feedbackDetail',
  initialState: {
    data: null as any,
    loading: false,
    error: null as string | null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getFeedbackReportDetails
      .addCase(getFeedbackReportDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFeedbackReportDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getFeedbackReportDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export { getFeedbackReportDetails };
export default feedbackDetailSlice.reducer;
